import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type MtpNumericState = number;
type MtpBoxSizeState = boolean | number | string;

/**
 * MtpExtrasStateService
 * --------------------------------------------------------------------
 * MTP restore/max streams that live at the coordinator level (not
 * inside per-feature data). Also carries the shared
 * `showNextMultiSuccessBtn` and `userBoxSizeValue` for the multi-driver
 * flows.
 */
@Injectable({ providedIn: "root" })
export class MtpExtrasStateService {
  readonly tcDeltaMTPtValue = new BehaviorSubject<MtpNumericState>(0);
  readonly getTCDeltaValueMTP: Observable<MtpNumericState> = this.tcDeltaMTPtValue.asObservable();
  readonly mtpDimStartMax = new BehaviorSubject<MtpNumericState>(0);
  readonly getMtpDimStartMax: Observable<MtpNumericState> = this.mtpDimStartMax.asObservable();
  readonly mtpDimStopMax = new BehaviorSubject<MtpNumericState>(0);
  readonly getMtpDimStopMax: Observable<MtpNumericState> = this.mtpDimStopMax.asObservable();
  readonly mtpDimLevelMax = new BehaviorSubject<MtpNumericState>(0);
  readonly getMtpDimLevelMax: Observable<MtpNumericState> = this.mtpDimLevelMax.asObservable();

  readonly showNextMultiSuccessBtn = new BehaviorSubject<boolean>(false);
  readonly getShowNextMultiSuccessBtn: Observable<boolean> =
    this.showNextMultiSuccessBtn.asObservable();
  readonly userBoxSizeValue = new BehaviorSubject<MtpBoxSizeState>(false);
  readonly getUserBoxSizeValue: Observable<MtpBoxSizeState> = this.userBoxSizeValue.asObservable();

  setMTPTcDeltaValue(value: MtpNumericState): void {
    this.tcDeltaMTPtValue.next(value);
  }
  setMTPDimStopMax(value: MtpNumericState): void {
    this.mtpDimStopMax.next(value);
  }
  setMTPDimStartMax(value: MtpNumericState): void {
    this.mtpDimStartMax.next(value);
  }
  setMTPDimLevelMax(value: MtpNumericState): void {
    this.mtpDimLevelMax.next(value);
  }
  sendShowNextSuccessBtnMulti(data: boolean): void {
    this.showNextMultiSuccessBtn.next(data);
  }
  sendMultiBoxSizeUser(data: MtpBoxSizeState): void {
    this.userBoxSizeValue.next(data);
  }
}
